import React from 'react'
import DeleteButton from './delete-button'

const ItemWrapper = ({ children }) => (
  <div style={{ display: 'flex', position: 'relative' }}>
    {children}
  </div>
)

const Item = ({ component: ItemComponent, onRef, deletable, onDelete, style, ...componentProps }) => (
  <ItemWrapper>
    <ItemComponent
      style={{ flexGrow: 1, ...style }}
      ref={onRef}
      {...componentProps}
    />

    {deletable
      ? <DeleteButton onClick={onDelete} />
      : null}
  </ItemWrapper>
)

// @ts-ignore
Item.propTypes = {
  name: React.PropTypes.string.isRequired,
  value: React.PropTypes.any,
// @ts-ignore
  component: React.PropTypes.elementType.isRequired,
  deletable: React.PropTypes.bool,
  onDelete: React.PropTypes.func.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onRef: React.PropTypes.func,
  style: React.PropTypes.object
}

// @ts-ignore
Item.defaultProps = {
  deletable: false,
  style: {},
  onRef: () => {}
}

export default Item
